import { render } from "./ButtonGroup.vue?vue&type=template&id=3db8dd77&scoped=true"
import script from "./ButtonGroup.vue?vue&type=script&lang=js"
export * from "./ButtonGroup.vue?vue&type=script&lang=js"

import "./ButtonGroup.vue?vue&type=style&index=0&id=3db8dd77&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3db8dd77"],['__file',"src/views/UserManagement/SelfRegistration/components/ButtonGroup.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3db8dd77"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3db8dd77', __exports__)) {
    api.reload('3db8dd77', __exports__)
  }
  
  module.hot.accept("./ButtonGroup.vue?vue&type=template&id=3db8dd77&scoped=true", () => {
    api.rerender('3db8dd77', render)
  })

}


export default __exports__